import { render, staticRenderFns } from "./Deactivate.vue?vue&type=template&id=775c8e9e&scoped=true"
import script from "./Deactivate.vue?vue&type=script&lang=js"
export * from "./Deactivate.vue?vue&type=script&lang=js"
import style0 from "./Deactivate.vue?vue&type=style&index=0&id=775c8e9e&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775c8e9e",
  null
  
)

export default component.exports